module.exports = fs;